<div class="tarjeta azul">
    <div class="caja">
        <div class="brand">
            {{tarjeta?.brand}}
        </div>

        <div class="name">
            {{cuenta?.firstName}} {{cuenta?.lastName}}
        </div>

        <div class="number">
            <div class="point"></div>
            <div class="point"></div>
            <div class="point"></div>
            <div class="point"></div>
            <div class="last">{{tarjeta?.last4}}</div>
        </div>

    </div>
</div>